import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';

/**
 * Dialogue de confirmation générique et réutilisable (warning + action danger).
 * Utilisé pour les suppressions (planche, zone…) afin de ne pas dupliquer un bouton/dialogue partout.
 */
@Component({
  selector: 'vw-confirm-dialog',
  standalone: true,
  imports: [CommonModule, TranslatePipe, SharedModule],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() message = '';
  @Input() confirmLabel = '';
  @Input() cancelLabel = '';
  @Input() danger = true;
  @Input() loading = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
